<template lang="pug">
.main
  v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
    v-form(ref="masjidtanahForm")

      p.body-2.mt-4 Pendaftaran dibuka kepada para peniaga di dalam Parlimen Masjid Tanah yang berminat untuk  berniaga secara online di platform E-Pasaria Masjid Tanah.

      b Tawaran Istimewa Kepada 100 Peniaga Terawal

      div.text-left
        p.mt-3.mb-1 50 peniaga terawal yang mendaftar:
        p.body-2.grey--text PERCUMA untuk sebulan pertama (Kos biasa RM50/bulan, ditanggung sepenuhnya oleh Pusat Khidmat Parlimen Masjid Tanah)

        p.mt-3.mb-1 50 peniaga seterusnya yang mendaftar:
        p.body-2.grey--text Bayar RM 10/bulan sahaja untuk sebulan pertama (Kos selebihnya ditanggung oleh Pusat Khidmat Parlimen Masjid Tanah).


        p.mb-1 Apa yang kamu para peniaga akan dapat dari inisiatif ini?

        div.font-weight-bold 1. Memudahkan customer pilih dan order dalam whatsapp
        div.font-weight-bold 2. Mudah untuk peniaga menguruskan order.
        div.font-weight-bold 3. Memudahkan peniaga mendapatkan dan menganalisa info jualan.

      p.mt-4 Daftar sekarang untuk mulakan perniagaan online kamu.

      v-text-field(color="primary" v-model="form.email" type="email" label="Email address" @keyup.enter="validateMasjidTanah" outlined :rules="rules.email")
      v-text-field(color="primary" v-model="project.postcode" type="text" label="Postcode number" @keyup.enter="validateMasjidTanah" outlined :rules="rules.postcode")
      v-btn.font-weight-bold(color="accent" x-large block depressed @click="validateMasjidTanah" :loading="loading") Continue
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ValidateProjectMasjidtanah',
  data: () => ({
    loading: false,
    projectId: null,
    form: {
      email: '',
    },
    project: {
      id: null,
      postcode: ''
    },
    rules: {
      email: [
        v => !!v || 'E-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      postcode: [
        v => !!v || 'Postcode is required'
      ]
    }
  }),
  mounted () {
    this.project.id = this.$route.query.project
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    validateMasjidTanah() {
      if (!this.$refs.masjidtanahForm.validate()) {
        return
      }

      if (!['76300', '78100', '78200', '78300'].includes(this.project.postcode)) {
        this.showMessage(['error', this.$t('error_message.sorry_not_eligible')])
        return
      }

      this.loading = true
      this.$axios.get(`/sponsors/${this.project.id}/`)
        .then(resp => {
          if (resp.full) {
            this.loading = false
            this.showMessage(['error', this.$t('error_message.sorry_no_open_seats')])
          } else {
            this.$emit('verified', this.form.email)
          }
        })
        .catch(() => {
          this.loading = false
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>